export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/minecraft.c10d03a.svg";